import get from 'lodash/get';

import type { PipelineContext } from '../../../core/types';
import { SubmitValidationError, resolveSubmitOverlayText } from '../../_shared/common/submit/submitValidation';
import type { EbmSpec } from './schema';
import { parseEbmResourceConfiguration } from './spec';

/** 硬件对象是否可用于提交：须有有效 resource.size（避免仅有 vendor/device 的空壳） */
function hasHardwareRecord(record: Record<string, unknown> | undefined): boolean {
  if (!record || typeof record !== 'object') return false;
  const size = get(record, 'resource.size');
  return size != null && String(size).trim() !== '';
}

/** 弹性裸金属提交前必填校验（下单别名/租户在 orderForm → overlay，不在 innerForm） */
export function assertEbmSubmitReady(spec: EbmSpec, ctx: PipelineContext): void {
  /** overlay.alias/name 来自订单基本信息 name；直建仍读 spec.alias */
  const alias = resolveSubmitOverlayText(ctx.overlay?.alias, ctx.overlay?.name, spec.alias);
  if (!alias) {
    throw new SubmitValidationError('弹性裸金属别名为必填项');
  }
  const workspace = resolveSubmitOverlayText(ctx.overlay?.workspace, spec.workspace);
  if (!workspace) {
    throw new SubmitValidationError('弹性裸金属租户空间为必填项');
  }
  const bundle = parseEbmResourceConfiguration(spec.resourceConfigurationRaw);
  if (!hasHardwareRecord(bundle?.cpu) || !hasHardwareRecord(bundle?.memory)) {
    throw new SubmitValidationError('请选择资源配置');
  }

  const disk = spec.systemDisk;
  if (!disk?.diskSize && !disk?.diskName) {
    throw new SubmitValidationError('请配置系统盘');
  }

  // system 由 serialize 从 systemDisk 派生，fromForm 不写 spec.system；新建盘校验镜像元数据
  if (disk?.sourceKind !== 'existing') {
    const image = disk?.image;
    if (!image?.os || !image?.version) {
      throw new SubmitValidationError('系统镜像信息不完整');
    }
  }

  void ctx;
}
